import TagManager from 'react-gtm-module'

type DataLayerPayload = Record<string, unknown> & { event: string }

/**
 * GTM dataLayer への送信を try/catch で包む薄いラッパ。
 *
 * Why: GA4 / GTM はあくまでトラッキング層であり、ここでの例外が
 * 業務フローを止めてはならない (issue #1987 の方針)。
 * react-gtm-module 自体が window.dataLayer 未定義時に throw するため
 * 呼び出し側でラップせずに直接呼ぶと SSR / hydration / blocker 拡張下で
 * アプリ全体が落ちるリスクがある。
 *
 * SSR ガード: Cloudflare Workers などサーバ側 render では window が無く、
 * 毎リクエスト warn が出ると無駄なので早期 return する。
 */
export const safeDataLayer = (payload: DataLayerPayload): void => {
  if (typeof window === 'undefined') return
  try {
    TagManager.dataLayer({ dataLayer: payload })
  } catch (e) {
    console.warn('[gtm] dataLayer push failed', e)
  }
}

/**
 * GTM の初期化を try/catch で包む薄いラッパ。
 * GTM スクリプトの差込み失敗で React の render が止まることを防ぐ。
 */
export const safeInitializeGtm = (gtmId: string): void => {
  if (typeof window === 'undefined') return
  try {
    TagManager.initialize({ gtmId })
  } catch (e) {
    console.warn('[gtm] initialize failed', e)
  }
}
